import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, KeepAlive as _KeepAlive, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 1
};
const _hoisted_2 = {
    id: "microAppContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mp_watermark = _resolveComponent("mp-watermark");
    const _component_router_view = _resolveComponent("router-view");
    const _component_Layout = _resolveComponent("Layout");
    return _openBlock(), _createElementBlock("div", null, [
        _ctx.user ? (_openBlock(), _createBlock(_component_mp_watermark, {
            key: 0,
            content: _ctx.user,
            opacity: 0.1,
            fullscreen: "",
            "offset-x": 10,
            "offset-y": 10,
            "gap-x": 50,
            "gap-y": 50,
            font: {
                fontSize: 12
            },
            "z-index": 99999
        }, null, 8, [
            "content"
        ])) : _createCommentVNode("", true),
        _ctx.isWhiteListPage ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_router_view)
        ])) : (_openBlock(), _createBlock(_component_Layout, {
            key: 2
        }, {
            default: _withCtx(()=>[
                    _createVNode(_component_router_view, null, {
                        default: _withCtx((param)=>{
                            let { Component } = param;
                            return [
                                (_openBlock(), _createBlock(_KeepAlive, null, [
                                    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
                                        [
                                            _vShow,
                                            _ctx.isMicroApp
                                        ]
                                    ])
                                ], 1024)),
                                (_openBlock(), _createBlock(_KeepAlive, {
                                    exclude: "AssistantIndex"
                                }, [
                                    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(Component), null, null, 512)), [
                                        [
                                            _vShow,
                                            !_ctx.isMicroApp
                                        ]
                                    ])
                                ], 1024))
                            ];
                        }),
                        _: 1
                    })
                ]),
            _: 1
        })),
        _ctx.ballEnabled && _ctx.hasAgiGateway ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.AssistantBall), {
            key: 3
        })) : _createCommentVNode("", true)
    ]);
}
